import { GetterTree } from "vuex";
import { IErrorState } from "@/store/modules/error/types";
import { RootState } from "@/store/types";

type ErrorGetter = GetterTree<IErrorState, RootState>;

export const getters: ErrorGetter = {
  getErrorMsgs(state: IErrorState): string[] {
    const { errorArray } = state;
    return errorArray;
  },
  getErrorStatus(state: IErrorState): boolean {
    const { error } = state;
    return error;
  },
};
